import { post, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR, {mutate} from 'swr'
import { handleApiResponse } from './api_util';


async function startCaseInstance(caseID){
    const payload={
        apiName: 'LivisiblyAdminApi',
        path: `start_instance/case/${caseID}`,
        options: {
          body: {
          }
        }
      }

      const restOperation = post(payload);


      const response = await restOperation.response;
      return processResponse(response)
  }

  async function stopCaseInstance(caseID){
    const payload={
        apiName: 'LivisiblyAdminApi',
        path: `stop_instance/case/${caseID}`,
        options: {
          body: {
          }
        }
      }

      const restOperation = post(payload);


      const response = await restOperation.response;
      return processResponse(response)
  }


async function pauseCaseDiscovery(caseID){
    const payload={
        apiName: 'LivisiblyAdminApi',
        path: `pause_discovery/case/${caseID}`,
        options: {
          body: {
          }
        }
      }

      const restOperation = post(payload);


      const response = await restOperation.response;
      return processResponse(response)
  }

  async function resumeCaseDiscovery(caseID){
    const payload={
        apiName: 'LivisiblyAdminApi',
        path: `resume_discovery/case/${caseID}`,
        options: {
          body: {
          }
        }
      }

      const restOperation = post(payload);


      const response = await restOperation.response;
      return processResponse(response)
  }


async function setCaseCheckImageAccess(caseID, tier){
    const payload={
        apiName: 'LivisiblyAdminApi',
        path: `set_check_image_access/case/${caseID}`,
        options: {
          body: {
            tier: tier,
          }
        }
      }

      const restOperation = post(payload);


      const response = await restOperation.response;
      return processResponse(response)
  }


export function useStopCaseInstance() {
    return async (caseID,existingData) => {
      const optimisticData = {
        ...existingData,
        db_state: {
          instance_state: 'stopping'
        }
      };
      const options = {
      optimisticData: optimisticData,
      populateCache: false,
      revalidate: true,
      rollbackOnError: true
    }
        mutate(['CACHED_CASE_STATS', caseID],stopCaseInstance(caseID),options);
    };
  }

export function useStartCaseInstance() {
    return async (caseID,existingData) => {
      const optimisticData = {
        ...existingData,
        db_state: {
          instance_state: 'starting'
        }
      };
      const options = {
      optimisticData: optimisticData,
      populateCache: false,
      revalidate: true,
      rollbackOnError: true
    }
        mutate(['CACHED_CASE_STATS', caseID],startCaseInstance(caseID),options);
    };
  }

export function usePauseCaseDiscovery() {
    return async (caseID, existingData) => {
      const optimisticData = {
        ...existingData,
        discovery_status: {
          ...(existingData?.discovery_status || {}),
          state: 'idle',
          reasons: {
            ...((existingData?.discovery_status || {}).reasons || {}),
            paused: true,
          },
        },
      };
      const options = {
        optimisticData: optimisticData,
        populateCache: false,
        revalidate: true,
        rollbackOnError: true
      }
        mutate(['CACHED_CASE_STATS', caseID], pauseCaseDiscovery(caseID), options);
    };
  }

export function useResumeCaseDiscovery() {
    return async (caseID, existingData) => {
      const optimisticData = {
        ...existingData,
        discovery_status: {
          ...(existingData?.discovery_status || {}),
          reasons: {
            ...((existingData?.discovery_status || {}).reasons || {}),
            paused: false,
          },
        },
      };
      const options = {
        optimisticData: optimisticData,
        populateCache: false,
        revalidate: true,
        rollbackOnError: true
      }
        mutate(['CACHED_CASE_STATS', caseID], resumeCaseDiscovery(caseID), options);
    };
  }

// Set the per-case check-image access tier (NO_ACCESS | DEPOSITS | FULL).
// Unlike discovery (which lives on the EC2-dependent case-stats cache), this
// entitlement is a primary-DB :Case property that rides in the ['ORGCASES']
// list payload — so we optimistically patch item.case.checkImageAccess there,
// then revalidate. Rollback = revalidate on error (same as the delete flow).
export function useSetCheckImageAccess() {
    return async (caseID, tier) => {
      mutate(
        ['ORGCASES'],
        (cur) => Array.isArray(cur)
          ? cur.map((it) => it.case?.caseID === caseID
              ? { ...it, case: { ...it.case, checkImageAccess: tier } }
              : it)
          : cur,
        { revalidate: false },
      );
      try {
        const response = await setCaseCheckImageAccess(caseID, tier);
        mutate(['ORGCASES']);
        return response;
      } catch (err) {
        mutate(['ORGCASES']); // revalidate to roll back the optimistic patch
        throw err;
      }
    };
  }

